import 'core-js/stable';
import '@fontsource/inter/400.css';
import '@fontsource/inter/500.css';
import '@fontsource/inter/600.css';
import '@fontsource/inter/700.css';
import '@fontsource/plus-jakarta-sans/400.css';
import '@fontsource/plus-jakarta-sans/500.css';
import '@fontsource/plus-jakarta-sans/600.css';
import '@fontsource/plus-jakarta-sans/700.css';
import '@fontsource/source-serif-4/400.css';
import '@fontsource/source-serif-4/500.css';
import '@fontsource/source-serif-4/600.css';
import '@fontsource/source-serif-4/700.css';
import '@fontsource/manrope/400.css';
import '@fontsource/manrope/500.css';
import '@fontsource/manrope/600.css';
import '@fontsource/manrope/700.css';
import '@fontsource/manrope/800.css';
import './css/tokens.css';
import './css/clinical_tokens.css';
import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { createBrowserHistory } from 'history';
import rootReducer from './reducers';
import App from './App';
import ReactGA from 'react-ga';
import smoothscroll from 'smoothscroll-polyfill';
import { CookiesProvider } from 'react-cookie';

export const history = createBrowserHistory();

const store = configureStore({
  reducer: rootReducer,
});

if (gon.ga_id) {
  ReactGA.initialize(gon.ga_id);
}
// kick off the polyfill!
smoothscroll.polyfill();

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter history={history}>
      <CookiesProvider>
        <App />
      </CookiesProvider>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root'),
  () => {
    // Signal that React has finished rendering
    if (document.body) {
      document.body.classList.add('react-loaded');
      document.body.classList.remove('react-loading');
      document.body.classList.add('fs-unmask');
    }
  }
);
